import { render, staticRenderFns } from "./VoicemailList.vue?vue&type=template&id=23e77ee7&"
import script from "./VoicemailList.vue?vue&type=script&lang=ts&"
export * from "./VoicemailList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports